/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BlockContent } from '../../models/block-content';
import { CriteriaContentObject } from '../../models/criteria-content-object';

export interface ApiMasterBlockContentGetByCriteriaPost$Params {
      body?: CriteriaContentObject
}

export function apiMasterBlockContentGetByCriteriaPost(http: HttpClient, rootUrl: string, params?: ApiMasterBlockContentGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BlockContent>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterBlockContentGetByCriteriaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BlockContent>>;
    })
  );
}

apiMasterBlockContentGetByCriteriaPost.PATH = '/api/Master/BlockContent/GetByCriteria';
